import { render, staticRenderFns } from "./AddPart.vue?vue&type=template&id=74610f37&scoped=true"
import script from "./AddPart.vue?vue&type=script&lang=js"
export * from "./AddPart.vue?vue&type=script&lang=js"
import style0 from "./AddPart.vue?vue&type=style&index=0&id=74610f37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74610f37",
  null
  
)

export default component.exports